//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQAvatarUploader from "@/components/Generics/AQAvatarUploader/AQAvatarUploader.vue";
// import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQAvatarUploader,
        // AQToggle,
        AQInput
    },
    data() {
        return {
            toggleValue: false,
            extensions: ".jpg,.png,.svg"
        };
    },

    computed: {},
    methods: {
    }
};

